export default "__VITE_ASSET__yB5RxsBV__"